/**
 * System wide helpers
 *
 * NOTE(mattjs) Do not clutter this with things that do not belong here this
 * namespace is for core functionality that may also depend on other modules
 */
goog.provide('yext.helpers');

/**
 * Adds a before unload message to make sure that the user is finished
 * editing before navigating away from the page
 *
 * @param {string} message An optional message for the before upload dialog
 */
yext.helpers.addBeforeUnloadMessage = function(message) {
  window.onbeforeunload = function(e) {
    e = e || window.event;
    message = message || yext.msg('You\'ve made changes that you have not saved. If you leave this page, your changes will be lost.');
    if (e) {
      e.returnValue = message;
    }
    return message;
  };
};

/**
 * Clears the before unload message
 */
yext.helpers.clearBeforeUnloadMessage = function() {
  window.onbeforeunload = null;
};

/**
 * Escape a string that you would like to build a regular expression with
 *
 * Special characters that must be escaped: \ ^ $ * + ? . ( ) | { } [ ]
 */
yext.helpers.escapeRegExp = (function() {
  var re = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;
  return function(str) {
    return str.replace(re, '\\$&');
  };
})();

/**
 * Construct AM/PM time string.
 * @param {integer} hour 24hr wall-clock.
 * @param {integer} minute
 * @returns {string} formatted HHMMA time
 */
yext.helpers.formatTimeHHMMA = function(hour, minute) {
  var hour12 = hour % 12 || 12;
  return (hour12 < 10 ? '0' : '') + hour12 + ':' + (minute < 10 ? '0' : '') + minute + ' ' + (hour < 12 ? 'AM' :'PM');
};

yext.helpers.formatDateMMDDYYYY = function(month, day, year) {
  return (month < 10 ? '0' : '') + month + '/' + (day < 10 ? '0' : '') + day + '/' + year;
};
